import React from 'react';
import {Router, Switch, Route} from 'react-router-dom';
import history from './history';
import Loading from './Components/Loading';

/**
 * Projects import lazy load
 */
import asyncComponent from './AsyncComponent';

const Home = asyncComponent(() => {
        showLoading();
        return import('./Components/Home').then(module => {
            hideLoading();
            return module.default;
        });
    }
);

const CarDealerShipHome = asyncComponent(() => {
        showLoading();
        return import('./Projects/CarDealerShip/pages/CarDealerShipHome').then(module => {
            hideLoading();
            return module.default;
        });
    }
);

const CarDealerShipList = asyncComponent(() => {
        showLoading();
        return import('./Projects/CarDealerShip/pages/CarDealerShipList').then(module => {
            hideLoading();
            return module.default;
        });
    }
);

const CarDealerShipComparer = asyncComponent(() => {
        showLoading();
        return import('./Projects/CarDealerShip/pages/CarDealerShipComparer').then(module => {
            hideLoading();
            return module.default;
        });
    }
);

const CarDealerShipPrice = asyncComponent(() => {
        showLoading();
        return import('./Projects/CarDealerShip/pages/CarDealerShipPrice').then(module => {
            hideLoading();
            return module.default;
        });
    }
);

const showLoading = () => {
    if (window.document.querySelector(".Loading"))
        window.document.querySelector(".Loading").style.display = "block";
};
const hideLoading = () => {
    if (window.document.querySelector(".Loading"))
        window.document.querySelector(".Loading").style.display = "none";
    if (window.document.querySelector(".front10-dashboard-project__initialInfo"))
        window.document.querySelector(".front10-dashboard-project__initialInfo").style.display = "none";
};

class AppRouter extends React.Component {
    constructor(props) {
        super(props);
        this.state = {loading: false};
    }

    render() {
        return (
            <Router history={history}>
                <div className="h-100">
                    <Loading/>
                    <Switch>
                        <Route path="/cardealership/home" exact component={CarDealerShipHome}/>
                        <Route path="/cardealership/finder" exact component={CarDealerShipList}/>
                        <Route path="/cardealership/price" exact component={CarDealerShipPrice}/>
                        <Route path="/cardealership/comparer" exact component={CarDealerShipComparer}/>                        
                        <Route path="/" exact component={Home}/>
                    </Switch>
                </div>
            </Router>
        )
    }
}

export default AppRouter;



// WEBPACK FOOTER //
// ./src/routes.js